/**
 * Demo booking destination.
 *
 * Update CALENDLY_URL once the real Calendly account is provisioned.
 * Used by /book-demo (inline embed) and any external demo CTAs.
 */
export const CALENDLY_URL = "https://calendly.com/dean-sorvaine/sorvaine-rfp-platform";

/** Fallback contact email for visitors who prefer not to use Calendly. */
export const DEMO_FALLBACK_EMAIL = "hello@sorvaine.com";
